import React from 'react';

const HalfBanner = () => {
    return (
        <div className="banner2 banner_half border-radious5 mb20 mt20">
            <iframe
                title="halfBanner"
                id="ac1cacf8"
                name="ac1cacf8"
                src="https://cm2.regiohealth.net/cma/www/delivery/afr.php?zoneid=16&amp;target=_blank&amp;cb=234"
                width="234"
                height="60"
                frameBorder="0"
                allow="autoplay"
            >
                <a
                    href="https://cm2.regiohealth.net/cma/www/delivery/ck.php?n=a97333e9&amp;cb=234"
                    target="_blank"
                >
                    <img
                        src="https://cm2.regiohealth.net/cma/www/delivery/avw.php?zoneid=16&amp;cb=234&amp;n=a97333e9"
                        border="0"
                        alt=""
                    />
                </a>
            </iframe>
        </div>
    );
};

export default HalfBanner;
